module.exports = __webpack_public_path__ + "img/teachingmanagement_4.b4c5a26c.jpg";